@if (property$ | async; as property) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: property }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: property }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <elder-basic-pane-layout class="flex">
        <!-- General -->
        <elder-pane>
          <elder-pane-header>
            <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
            <elder-pane-actions>
              <!--            <button mat-icon-button-->
              <!--                    [disabled]="!mainFrm.form.valid"-->
              <!--                    (click)="onSave($event)">-->
              <!--              <mat-icon>save</mat-icon>-->
              <!--            </button>-->
              <!--            <button mat-icon-button-->
              <!--                    [matMenuTriggerFor]="menu"-->
              <!--                    [disabled]="creationMode">-->
              <!--              <mat-icon>more_vert</mat-icon>-->
              <!--            </button>-->
              <!--            <mat-menu #menu="matMenu">-->
              <!--              <button mat-menu-item-->
              <!--                      (click)="onDelete($event)"-->
              <!--                      [disabled]="!deletionEnabled">-->
              <!--                <mat-icon>delete</mat-icon>-->
              <!--                <span>{{'actions.delete' | translate}}</span>-->
              <!--              </button>-->
              <!--            </mat-menu>-->
            </elder-pane-actions>
          </elder-pane-header>
          <elder-pane-content>
            <form #mainFrm="ngForm" class="flex layout-row gap-xl">
              <div class="flex layout-col">
                <!-- Identifications -->
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  <!-- ID input -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.id' | translate }}</mat-label>
                    <input
                      matInput
                      name="id"
                      #idModel="ngModel"
                      required
                      [disabled]="!creationMode"
                      placeholder="{{ 'context.id' | translate }}"
                      pattern="{{ idValidatorPattern }}"
                      [(ngModel)]="property.id"
                    />
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                  <!-- propertyPath input field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'Path' | translate }}</mat-label>
                    <input
                      matInput
                      name="propertyPath"
                      disabled
                      placeholder="{{ 'Path' | translate }}"
                      [(ngModel)]="property.propertyPath"
                    />
                  </mat-form-field>
                  <!-- Kind input -->
                  <mat-form-field>
                    <mat-label>{{ 'context.kind' | translate }}</mat-label>
                    <elder-select
                      appPropertyKindSelect
                      name="kind"
                      class="flex"
                      required
                      valueAsId
                      [disabled]="!creationMode"
                      [(ngModel)]="property.kind"
                    >
                    </elder-select>
                  </mat-form-field>
                  <!-- description input field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.description' | translate }}</mat-label>
                    <input
                      matInput
                      name="description"
                      disabled
                      placeholder="{{ 'context.description' | translate }}"
                      [(ngModel)]="property.description"
                    />
                  </mat-form-field>
                  <!-- default value field -->
                  <mat-form-field class="flex">
                    <mat-label>{{ 'context.defaultValue' | translate }}</mat-label>
                    <input
                      matInput
                      name="defaultValue"
                      disabled
                      placeholder="{{ 'context.defaultValue' | translate }}"
                      [(ngModel)]="property.defaultValue"
                    />
                  </mat-form-field>
                </div>
                <!-- Configuration (for Enumerations) -->
                @if (
                  property.type === propertyType.VALUE_ENUMERATION ||
                  property.type === propertyType.QUANTITY_ENUMERATION
                ) {
                  <div class="flex layout-col" style="padding-top: 24px">
                    <elder-pane-subtitle>{{ 'context.config' | translate }}</elder-pane-subtitle>
                    <mat-chip-set>
                      @for (val of property.values; track val) {
                        <mat-chip highlighted>{{ val }}</mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }
              </div>
              <div class="flex layout-col">
                <div class="layout-row gap-xl">
                  <!-- Property's type -->
                  <div class="flex layout-col">
                    <elder-pane-subtitle>{{ 'context.type' | translate }}</elder-pane-subtitle>
                    <div class="layout-row gap-md">
                      <mat-form-field>
                        <mat-label>{{ 'context.type' | translate }}</mat-label>
                        <elder-select
                          name="type"
                          required
                          [data]="propertyTypeList"
                          [disabled]="!creationMode"
                          [(ngModel)]="property.type"
                          (valueChange)="reevaluateUnit(property.type)"
                          placeholder="{{ 'context.type' | translate }}"
                        >
                        </elder-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Property's unit -->
                  <div class="flex layout-col">
                    <elder-pane-subtitle>{{ 'context.unit' | translate }}</elder-pane-subtitle>
                    <div class="layout-row gap-md">
                      <mat-form-field>
                        <mat-label>{{ 'context.unit' | translate }}</mat-label>
                        <elder-select
                          name="unit"
                          [required]="propertyHasUnitInformation(property.type)"
                          [data]="unitList"
                          [disabled]="true"
                          [(ngModel)]="property.unit"
                          placeholder="{{ 'context.unit' | translate }}"
                        >
                        </elder-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="layout-row gap-xl">
                  <!-- Property's precision -->
                  <div class="flex layout-col">
                    <elder-pane-subtitle>{{ 'context.precision' | translate }}</elder-pane-subtitle>
                    <div class="layout-row gap-md">
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.precision' | translate }}</mat-label>
                        <input
                          matInput
                          name="precision"
                          disabled
                          placeholder="{{ 'context.precision' | translate }}"
                          [(ngModel)]="property.precision"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Property's rounding mode -->
                  <div class="flex layout-col">
                    <elder-pane-subtitle>{{
                      'context.roundingMode' | translate
                    }}</elder-pane-subtitle>
                    <div class="layout-row gap-md">
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.roundingMode' | translate }}</mat-label>
                        <input
                          matInput
                          name="roundingMode"
                          disabled
                          placeholder="{{ 'context.roundingMode' | translate }}"
                          [(ngModel)]="property.roundingMode"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </elder-pane-content>
        </elder-pane>
      </elder-basic-pane-layout>
    </div>
  </div>
}

<ng-template #header let-property>
  @if (creationMode) {
    <span>
      {{ 'properties.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'properties.property' | translate" [subheader]="'ID: ' + property.id">
    </elder-header>
  }
</ng-template>
